import TeamDetailMember from '@/screens/TeamDetailMember';

export default function PrivateTabsEventTeamTeamIdIndexRoute() {
  return <TeamDetailMember memberPathname="/event/team/member/[personId]" />;
}
